import { Component, effect, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';

import { DialogModule }    from 'primeng/dialog';
import { ButtonModule }    from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';

import { AuthService } from '../services/auth.service';
import { MfaChallengeService } from './mfa-challenge.service';

/**
 * Global MFA OTP modal. Rendered once at the app root; driven entirely by
 * `MfaChallengeService`, which the interceptor opens on a 403 MFA_TOKEN_REQUIRED.
 */
@Component({
  selector: 'app-mfa-challenge',
  standalone: true,
  imports: [CommonModule, FormsModule, DialogModule, ButtonModule, InputTextModule],
  templateUrl: './mfa-challenge.component.html'
})
export class MfaChallengeComponent {
  protected readonly svc = inject(MfaChallengeService);
  private   readonly auth   = inject(AuthService);
  private   readonly router = inject(Router);

  protected readonly otp = signal('');

  /** Clear the input whenever the dialog closes so the next challenge is blank. */
  private readonly _resetOnClose = effect(() => {
    if (!this.svc.visible()) { this.otp.set(''); }
  }, { allowSignalWrites: true });

  protected readonly canVerify = (): boolean =>
    this.svc.step() !== 'verifying' && /^\d{6}$/.test(this.otp().trim());

  protected confirm(): void {
    if (!this.canVerify()) { return; }
    this.svc.submitOtp(this.otp());
  }

  protected resend(): void {
    this.otp.set('');
    this.svc.resend();
  }

  /** Phone-missing path — send the user to where they can add a number. */
  protected goToManagePhone(): void {
    const url = this.auth.isEmployee() ? '/employee/profile' : '/employer/settings';
    this.svc.cancel();
    void this.router.navigateByUrl(url);
  }
}
